import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { buildApiUrl } from '../../../utils/apiUrl';
import BarChartComponent from './data/dashChartData';
import StatisticsModal from './StatisticsModal';
import CustomStatistics from './CustomStatistics';

// Icons
import { BsGraphUp } from 'react-icons/bs';
import { FaRegMoneyBillAlt, FaWpforms } from 'react-icons/fa';
import { LuUser } from 'react-icons/lu';
import { RiAdminLine } from 'react-icons/ri';

// SCSS
import '../../../assets/scss/Admin/Dashboard.scss';

const Dashboard = () => {
	const [stats, setStats] = useState({
		users: 0,
		userRoleUser: 0,
		userRoleAdmin: 0,
		ordersSent: 0,
		formsMonth: 0,
		mostFirm: '',
		userMostOrders: '',
		soMeProCount: 0,
		reachProCount: 0,
		reachEliteCount: 0,
		contentPremiumCount: 0,
		monthSoMeProCount: 0,
		monthReachProCount: 0,
		monthReachEliteCount: 0,
		monthContentPremiumCount: 0,
	});
	const [showStatsModal, setShowStatsModal] = useState(false);
	const [showCustomStats, setShowCustomStats] = useState(false);
	const [customStatsData, setCustomStatsData] = useState(null);
	const [customStatsFilters, setCustomStatsFilters] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const [userStats, orderStats, monthlyStats] = await Promise.all(
					[
						axios.get(buildApiUrl('statistics/user-stats')),
						axios.get(buildApiUrl('statistics/order-stats')),
						axios.get(buildApiUrl('statistics/monthly-order-stats')),
					]
				);

				const n = (v) => {
					const x = Number(v);
					return Number.isFinite(x) ? x : 0;
				};

				setStats({
					users: n(userStats.data.userCount),
					userRoleUser: n(userStats.data.userCount),
					userRoleAdmin: n(userStats.data.adminAndSuperAdminCount),
					ordersSent: n(orderStats.data.totalOrders),
					formsMonth: n(monthlyStats.data.monthlyOrderCount),
					mostFirm: monthlyStats.data.mostFrequentCompanyName || '',
					userMostOrders: monthlyStats.data.mostFrequentOrdererName || '',
					soMeProCount: n(orderStats.data.soMeProCount),
					reachProCount: n(orderStats.data.reachProCount),
					reachEliteCount: n(orderStats.data.reachEliteCount),
					contentPremiumCount: n(orderStats.data.contentPremiumCount),
					monthSoMeProCount: n(monthlyStats.data.soMeProCount),
					monthReachProCount: n(monthlyStats.data.reachProCount),
					monthReachEliteCount: n(monthlyStats.data.reachEliteCount),
					monthContentPremiumCount: n(monthlyStats.data.contentPremiumCount),
				});
			} catch (error) {
				console.error('Error fetching dashboard data:', error);
			}
		};

		fetchData();
	}, []);

	const handleGenerateStats = async (filters) => {
		try {
			const response = await axios.post(
				buildApiUrl('statistics/custom-stats'),
				filters
			);
			setCustomStatsData(response.data);
			setCustomStatsFilters(filters);
			setShowStatsModal(false);
			setShowCustomStats(true);
		} catch (error) {
			console.error('Error generating custom stats:', error);
		}
	};

	if (showCustomStats && customStatsData) {
		return (
			<CustomStatistics
				stats={customStatsData}
				filters={customStatsFilters}
				onBack={() => setShowCustomStats(false)}
			/>
		);
	}

	return (
		<div className='dashboard'>
			<div className='dashboard-actions'>
				<button type='button' onClick={() => setShowStatsModal(true)}>
					Lag statistikk
				</button>
			</div>
			<div className='dashboard-header'>
				<h1>Statistikk</h1>
			</div>
			{showStatsModal && (
				<StatisticsModal
					onClose={() => setShowStatsModal(false)}
					onGenerate={handleGenerateStats}
				/>
			)}
			<div className='dashboard__content'>
				<div className='topStats'>
					<div className='stats-card'>
						<div className='col'>
							<LuUser size='32' />
							<h3>Brukere registrert</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.users}</p>
						</div>
					</div>

					<div className='stats-card'>
						<div className='col'>
							<RiAdminLine size='32' />
							<h3>Admin brukere</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.userRoleAdmin}</p>
						</div>
					</div>

					<div className='stats-card'>
						<div className='col'>
							<FaWpforms size='32' />
							<h3>Ordre sendt</h3>
						</div>
						<div className='stats-number'>
							<p>{stats.ordersSent}</p>
						</div>
					</div>
				</div>

				<div className='middleStats'>
					<div className='middleStats__content row'>
						<div className='dailyReports'>
							<div className='top row'>
								<div className='col'>
									<h3>Månedlig rapport</h3>
									<p>ADA</p>
								</div>
								<BsGraphUp size='32' />
							</div>
							<div className='dailyReports__content'>
								<BarChartComponent />
							</div>
						</div>

						<div className='statsReport'>
							<div className='top row'>
								<div className='col'>
									<h3>Statistikk denne mnd</h3>
									<p>ADA</p>
								</div>
								<FaRegMoneyBillAlt size='32' />
							</div>
							<div className='statsReport__content'>
								<div className='row'>
									<div className='col'>
										<div className='col new-item'>
											<h3>Antall skjema</h3>
											<p>{stats.formsMonth}</p>
										</div>
										<div className='col new-item'>
											<h3>Pakker denne mnd</h3>
											<p>
												SoMe Pro: {stats.monthSoMeProCount} · Reach Pro:{' '}
												{stats.monthReachProCount} · Reach Elite:{' '}
												{stats.monthReachEliteCount} · Content Premium:{' '}
												{stats.monthContentPremiumCount}
											</p>
										</div>
									</div>
									<div className='col'>
										<div className='col new-item'>
											<h3>Største firma</h3>
											<p>{stats.mostFirm}</p>
										</div>
										<div className='col new-item'>
											<h3>Flest bestillinger</h3>
											<p>{stats.userMostOrders}</p>
										</div>
									</div>
								</div>
								<div className='row' style={{ marginTop: '0.75rem' }}>
									<div className='col new-item'>
										<h3>Pakker totalt (alle skjema)</h3>
										<p>
											SoMe Pro: {stats.soMeProCount} · Reach Pro:{' '}
											{stats.reachProCount} · Reach Elite: {stats.reachEliteCount}{' '}
											· Content Premium: {stats.contentPremiumCount}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
